<div class="container-fluid">
  <!-- Page Title -->
  <!-- <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between" style="background-color: #B71C1C; padding: 1rem; border-radius: 0.375rem; margin-bottom: 1.5rem;">
        <h4 class="mb-sm-0" style="color: white;">
          <i class="ri-file-list-3-line me-2"></i>Incident List
        </h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0" style="background-color: transparent; padding: 0;">
            <li class="breadcrumb-item">
              <a href="javascript: void(0);" style="color: rgba(255, 255, 255, 0.8);">Incidents</a>
            </li>
            <li class="breadcrumb-item active" style="color: white;">List</li>
          </ol>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Incident List -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="card-title mb-0" style="color: white;">
              <i class="ri-file-list-3-line me-2"></i>{{ 'INCIDENTS.ALLINCIDENTS' | translate }}
            </h5>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm" (click)="refreshIncidents()" style="background-color: white; color: #B71C1C; border-color: white;">
                <i class="ri-refresh-line align-middle"></i> {{ 'INCIDENTS.REFRESH' | translate }}
              </button>
              <a routerLink="/incidents/create"  *ngIf="roleService.hasRole(['admin'])" class="btn btn-sm" style="background-color: white; color: #B71C1C; border-color: white;    ">
                <i class="ri-add-line align-middle"></i> {{ 'INCIDENTS.REPORTNEWINCIDENT' | translate }}
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Loading State -->
          <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border" role="status" style="color: #B71C1C;">
              <span class="visually-hidden">{{ 'INCIDENTS.LOADINGINCIDENTS' | translate }}</span>
            </div>
            <p class="mt-2 text-muted">{{ 'INCIDENTS.LOADINGINCIDENTS' | translate }}</p>
          </div>

          <!-- Error State -->
          <div *ngIf="error" class="alert alert-danger" role="alert">
            <i class="ri-error-warning-line me-2"></i>
            {{ error }}
          </div>

          <!-- Incident Table -->
          <div *ngIf="!loading && !error">
            <!-- Filters Section -->
            <div class="mb-3">
              <div class="row g-2">
                <!-- Status Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">{{ 'INCIDENTS.STATUS' | translate }}</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedStatus">
                    <option value="all">{{ 'INCIDENTS.ALL' | translate }}</option>
                    <option *ngFor="let status of incidentStatus" [value]="status">
                      {{'INCIDENTS.' + (status | uppercase) | translate }}
                    </option>
                  </select>
                </div>

                <!-- Fire Station Filter -->
                <div class="col-md-2"  *ngIf="!roleService.hasRole(['fire_station'])">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Fire Station</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedFireStationId">
                    <option [ngValue]="null">All Stations</option>
                    <option *ngFor="let station of fireStations" [ngValue]="station.id">
                      {{ station.name }}
                    </option>
                  </select>
                </div>

                <!-- Zone Filter -->
                <!-- <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Zone</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedZoneId" (change)="onZoneChange()">
                    <option [ngValue]="null">All Zones</option>
                    <option *ngFor="let zone of zones" [ngValue]="zone.id">
                      {{ zone.name }}
                    </option>
                  </select>
                </div> -->

                <!-- Ward Filter -->
                <!-- <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Ward</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedWardId" [disabled]="!selectedZoneId">
                    <option [ngValue]="null">All Wards</option>
                    <option *ngFor="let ward of wards" [ngValue]="ward.id">
                      {{ ward.wardName }}
                    </option>
                  </select>
                </div> -->

                <!-- Severity Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Severity</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedSeverityId">
                    <option [ngValue]="null">All Severities</option>
                    <option *ngFor="let severity of severities" [ngValue]="severity.id">
                      {{ severity.name }}
                    </option>
                  </select>
                </div>

              

                <!-- Start Date Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Start Date</label>
                  <input type="date" class="form-control form-control-sm" [(ngModel)]="selectedDate" />
                </div>

                <!-- End Date Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">End Date</label>
                  <input type="date" class="form-control form-control-sm" [(ngModel)]="selectedEndDate" />
                </div>

                <!-- Load Button -->
                <div class="col-md-1 d-flex align-items-end">
                  <button type="button" class="btn btn-sm w-100" style="background-color: #B71C1C; color: white;" (click)="applyFilters()">
                    <i class="ri-search-line align-middle"></i> Load
                  </button>
                </div>

                <!-- Reset Button -->
                <div class="col-md-1 d-flex align-items-end">
                  <button type="button" class="btn btn-sm btn-secondary w-100" (click)="refreshIncidents()">
                    <i class="ri-refresh-line align-middle"></i> Reset
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="incidents.length > 0" class="table-responsive">
              <table class="table table-hover align-middle table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">{{ 'INCIDENTS.INCIDENTNO' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.CONTACTPERSON' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.CONTACTNUMBER' | translate }}</th>
                    <!-- <th scope="col">Incident Type</th> -->
                    <th scope="col">{{ 'INCIDENTS.LOCATION' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.LANDMARK' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.SEVERITY' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.STATUS' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.REPORTEDAT' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.REMARKS' | translate }}</th>
                    <th scope="col" class="sticky-col">{{ 'INCIDENTS.ACTIONS' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let incident of incidents; let i = index">
                    <td><strong>{{ incident.incidentNo || 'N/A' }}</strong></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          <h6 class="mb-0">{{ incident.contactName || 'N/A' }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>{{ incident.contactNumber || 'N/A' }}</td>
                    <!-- <td>
                      <span class="badge" style="background-color: #B71C1C; color: white;">{{ incident.incidentType?.name || 'N/A' }}</span>
                    </td> -->
                    <td>
                      <div class="text-truncate" style="max-width: 200px;" title="{{ incident.location }}">
                        {{ incident.location || 'N/A' }}
                      </div>
                    </td>
                    <td>{{ incident.landmark || 'N/A' }}</td>
                    <td>
                      <span class="badge {{ getSeverityBadgeClass(incident) }}" 
                            [style.background-color]="getSeverityColor(incident)"
                            [style.color]="'white'">
                        {{ getSeverityText(incident) }}
                      </span>
                    </td>
                    <td>
                      <span class="badge" style="background-color: #6c757d; color: white;">{{ incident.status || 'N/A' }}</span>
                    </td>
                    <td>
                      <small class="text-muted">{{ formatDate(incident.reportedAt) }}</small>
                    </td>
                    <td>
                      <div class="text-truncate" style="max-width: 200px;" title="{{ incident.remarks }}">
                        {{ incident.remarks || 'N/A' }}
                      </div>
                    </td>
                    <td class="sticky-col">
                      <div class="d-flex gap-1">
                        <!-- Admin can assign vehicles or view details -->
                        <button type="button" class="btn btn-sm"  
                                style="background-color: #B71C1C; color: white; border-color: #B71C1C;"
                                [routerLink]="['/incidents', incident.id]"
                                [title]="incident.status === 'reported' ? ('INCIDENTS.ASSIGNVEHICLE' | translate) : ('INCIDENTS.VIEWDETAILS' | translate)"
                                *ngIf="roleService.hasRole(['admin']) ">
                                <i class="align-middle" [ngClass]="(incident.status === 'reported'  || incident.additionalRequestStatus==='pending' )  && incident.status!=='completed'? 'ri-truck-line' : 'ri-eye-line'"></i>
                        </button>
                        
                        <!-- Station in-charge can only view details -->
                        <button type="button" class="btn btn-sm btn-outline-primary"  
                                [routerLink]="['/incidents', incident.id]"
                                [title]="'INCIDENTS.VIEWDETAILS' | translate"
                                *ngIf="roleService.hasRole(['fire_station','adc_imc','dyc_imc','fire_chief_superintendent','adhoc_officers_fire_department_x2','commissioner_imc']) ">
                                <i class="align-middle ri-eye-line"></i>
                        </button>
                        
                        <button type="button" class="btn btn-sm btn-outline-secondary" 
                                [routerLink]="['/incidents', incident.id, 'assign-crew']"
                                [title]="'INCIDENTS.ASSIGNCREW' | translate"
                                *ngIf="roleService.hasRole(['fire_station'])   && (incident.status === 'dispatched' && !incident.crewInchargeUserId || incident.additionalRequestStatus==='vehicle_assigned' && incident.status!=='completed') ">
                          <i class="ri-team-line align-middle" ></i>
                        </button>
                        
                        <button type="button" class="btn btn-sm btn-warning" 
                                [routerLink]="['/incidents', incident.id, 'assign-crew']"
                                [title]="'Shift Change / Reassign'"
                                *ngIf="roleService.hasRole(['admin','fire_station']) && incident.crewInchargeUserId && incident.status !== 'completed'">
                          <i class="ri-refresh-line align-middle"></i>
                        </button>
                      </div>
                      <!-- <p>Role: {{ roleService.getRole() }}</p> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div *ngIf="incidents.length > 0" class="d-flex justify-content-between align-items-center mt-3">
              <div class="text-muted">
                Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} entries
              </div>
              <nav aria-label="Page navigation">
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" [class.disabled]="currentPage === 1">
                    <a class="page-link" (click)="onPageChange(1)" style="cursor: pointer;">
                      <i class="ri-arrow-left-double-line"></i>
                    </a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage === 1">
                    <a class="page-link" (click)="onPageChange(currentPage - 1)" style="cursor: pointer;">
                      <i class="ri-arrow-left-s-line"></i>
                    </a>
                  </li>
                  <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
                    <a class="page-link" (click)="onPageChange(page)" style="cursor: pointer;">{{ page }}</a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <a class="page-link" (click)="onPageChange(currentPage + 1)" style="cursor: pointer;">
                      <i class="ri-arrow-right-s-line"></i>
                    </a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <a class="page-link" (click)="onPageChange(totalPages)" style="cursor: pointer;">
                      <i class="ri-arrow-right-double-line"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <!-- Empty State -->
            <div *ngIf="incidents.length === 0" class="text-center py-5">
              <div class="mb-4">
                <i class="ri-file-list-3-line display-1 text-muted"></i>
              </div>
              <h5 class="text-muted">{{ 'INCIDENTS.NOINCIDENTSFOUND' | translate }}</h5>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
